import axiosInstance from './axiosInstance';

export const fetchKpiTable = async (startDate, endDate) => {
  return await axiosInstance
    .get(`/kpi`, {
      params: {
        startDate,
        endDate,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching KPI Table:', error);
      throw error;
    });
};

export const exportKpiTableToExcel = async (startDate, endDate) => {
  return await axiosInstance
    .get(`/kpi/export`, {
      params: {
        startDate,
        endDate,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching KPI Table:', error);
      throw error;
    });
};

export const fetchKpiYear = async (year) => {
  return await axiosInstance
    .get(`/kpi/year`, {
      params: {
        year,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching KPI Year:', error);
      throw error;
    });
};
